var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.elementClass,on:{"click":_vm.click}},[(_vm.d)?_c('svg',{ref:"svg",style:(_vm.sizeBox),attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":_vm.fill,"d":_vm.d}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }